/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Grower_Payment_Delete_ErrorInputs */

const vi_toast_grower_payment_delete_error = /** @type {(inputs: Toast_Grower_Payment_Delete_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá phiếu chuyển khoản thất bại`)
};

/**

* @param {Toast_Grower_Payment_Delete_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_grower_payment_delete_error = /** @type {((inputs?: Toast_Grower_Payment_Delete_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Grower_Payment_Delete_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_grower_payment_delete_error(inputs)
});